/* eslint-disable no-console */
import axios from "axios";
import store from "../store";
import { ResponseStatus } from "@/models/ResponseStatusEnum";

const APIUrl = process.env.VUE_APP_BASE_URL;

const axiosBase = axios.create({
  baseURL: APIUrl,
  headers: { "Content-Type": "application/json" }
});
const getAPI = axios.create({
  baseURL: APIUrl
});
// Necessary information for vlue server
const info = {
  device: "web/cpanel",
  version: window.navigator.appVersion,
  enviorment: process.env.NODE_ENV,
  user: ""
};

axiosBase.interceptors.request.use(
  config => {
    if (store.getters.loggedIn) {
      info.user = store.getters.username;
    }
    // SENDING X_INFO IN BASE 64
    /* eslint-disable @typescript-eslint/camelcase */
    config.headers.x_info = btoa(JSON.stringify(info));
    return config;
  },
  err => {
    Promise.reject(err);
  }
);

getAPI.interceptors.request.use(
  config => {
    if (store.getters.loggedIn) {
      info.user = store.getters.username;
    }
    // SENDING X_INFO IN BASE 64
    /* eslint-disable @typescript-eslint/camelcase */
    config.headers.x_info = btoa(JSON.stringify(info));
    const token = store.state.accessToken;
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  err => {
    Promise.reject(err);
  }
);
// REFRESHING TOKEN ON UNATHORIZED
let refreshing = false;
let subscribers = [] as (() => void)[];

function subscribePromise(cb: () => void): void {
  subscribers.push(cb);
}
function onRefreshed(): void {
  subscribers.map(cb => cb());
}
getAPI.interceptors.response.use(undefined, async err => {
  // if error response status is 401, it means the request was invalid due to expired access token
  const originalRequest = err.config;
  if (
    err.config &&
    err.response &&
    err.response.status === ResponseStatus.UNATHORIZED &&
    !originalRequest._retry
  ) {
    // Logout user if token refresh didn't work or user is disabled
    if (
      err.config.url.indexOf("api/rest/v1/auth/refreshToken") !== -1 ||
      err.response.message == "Account is disabled."
    ) {
      store.dispatch("logoutUser");
      return;
    }
    originalRequest._retry = true;
    if (!refreshing) {
      refreshing = true;
      store
        .dispatch("refreshToken")
        .then(() => {
          onRefreshed();
        })
        .catch(() => {
          throw err;
        })
        .finally(() => {
          refreshing = false;
          subscribers = [];
        });
    }
    const requestPromise = new Promise(resolve => {
      subscribePromise(() => {
        resolve(getAPI(originalRequest));
      });
    });
    return requestPromise;
  }
  throw err;
});
// END REFRESHING TOKEN ON UNATHORIZED
export { axiosBase, getAPI };
